import { gql } from 'urql';
import { PRODUCT } from '../client';

export const UPDATE_LOCATIONS_THIRD_PARTY_EXCLUSION = gql`
  mutation ${PRODUCT}UpdateLocationsThirdPartyExclusion($input: LocationsThirdPartyExclusionUpdateInput!) {
    updateLocationsThirdPartyExclusion(input: $input) {
      locations {
        id
        locationExcluded
        effectivelyExcluded
      }
      userErrors {
        ... on UserErrorInterface { message }
      }
    }
  }
`;
